import { useState } from "react";
import { LogOut } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { RegionSelect } from "../components/RegionSelect";
import { ShareButton } from "../components/ShareButton";
import { Switch } from "../components/ui/switch";
import { FormError } from "../components/AuthLayout";

function ChangePassword() {
  const [f, setF] = useState({ current_password: "", new_password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/change-password", f);
      setF({ current_password: "", new_password: "" });
      toast.success("Password changed");
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="brut-card p-5 space-y-4" data-testid="change-password-form">
      <h2 className="font-display uppercase text-xl">Change password</h2>
      <input className="brut-input" type="password" placeholder="Current password" required value={f.current_password}
        onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="change-password-current-input" />
      <input className="brut-input" type="password" placeholder="New password (8+)" minLength={8} required value={f.new_password}
        onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="change-password-new-input" />
      <FormError msg={error} testId="change-password-error" />
      <button className="brut-btn w-full" disabled={busy} data-testid="change-password-submit-btn">{busy ? "Saving…" : "Update password"}</button>
    </form>
  );
}

export default function Profile() {
  const { user, setUser, logout } = useAuth();

  const update = async (patch) => {
    try {
      const { data } = await api.patch("/profile", patch);
      setUser(data);
      toast.success("Profile updated");
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="space-y-6">
      <div>
        <span className="brut-label">Angler</span>
        <h1 className="font-display text-4xl sm:text-5xl uppercase leading-none" data-testid="profile-first-name">{user.first_name}</h1>
        <p className="text-sm text-zinc-400 mt-2" data-testid="profile-email">{user.email}</p>
      </div>

      <div className="brut-card p-5 space-y-3">
        <label className="brut-label">Fishing region</label>
        <RegionSelect value={user.region} onChange={(region) => update({ region })} testId="profile-region-select" />
        <p className="text-xs text-zinc-500">Used to check keeper sizes when you scan.</p>
      </div>

      <div className="brut-card p-5 flex items-center justify-between gap-4">
        <div>
          <h2 className="font-display uppercase">Appear on leaderboard</h2>
          <p className="text-xs text-zinc-400 mt-1">Shows your first name and catches publicly.</p>
        </div>
        <Switch checked={user.leaderboard_opt_in} onCheckedChange={(v) => update({ leaderboard_opt_in: v })}
          className="data-[state=checked]:bg-[#FF4D00] rounded-none [&>span]:rounded-none" data-testid="profile-leaderboard-switch" />
      </div>

      <ChangePassword />

      <ShareButton className="w-full" />
      <button className="brut-btn-ghost w-full" onClick={async () => { await logout(); window.location.assign("/"); }} data-testid="logout-btn">
        <LogOut size={18} /> Log out
      </button>
    </div>
  );
}
